import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React, { useRef } from 'react';
import Input from '../../input';
import { daveGrey } from '../../colors';
import CloseIcon from '../../icons/close';
import DefaultTheme from './theme';
export var InputTheme = DefaultTheme;
/*::
import type { Node, AbstractComponent, Config } from 'react';
import type {
  OptionType,
} from '../';
import type { InputThemeType } from './theme';

export type Props = {|
  option: ?OptionType,
  lookupText?: string,
  open: boolean,
  error?: boolean,
  disabled?: boolean,
  disableOptionClearing?: boolean,
  disableLookup?: boolean,
  onToggleDropdown?: (visible: boolean) => void;
  onClearOption?: any,
  onChange?: any,
  onFocus?: (e: FocusEvent) => void;
  onBlur?: (e: FocusEvent) => void;
  onKeyDown?: any,
  theme?: InputThemeType,
  rest?: any,
|}
*/

var SelectInput = function SelectInput(_ref
/*: Props */
) {
  var option = _ref.option,
      _ref$lookupText = _ref.lookupText,
      lookupText = _ref$lookupText === void 0 ? '' : _ref$lookupText,
      open = _ref.open,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$disableOptionCle = _ref.disableOptionClearing,
      disableOptionClearing = _ref$disableOptionCle === void 0 ? false : _ref$disableOptionCle,
      _ref$disableLookup = _ref.disableLookup,
      disableLookup = _ref$disableLookup === void 0 ? false : _ref$disableLookup,
      _ref$onToggleDropdown = _ref.onToggleDropdown,
      onToggleDropdown = _ref$onToggleDropdown === void 0 ? function () {
    return undefined;
  } : _ref$onToggleDropdown,
      _ref$onClearOption = _ref.onClearOption,
      onClearOption = _ref$onClearOption === void 0 ? function () {
    return undefined;
  } : _ref$onClearOption,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return undefined;
  } : _ref$onChange,
      _ref$onKeyDown = _ref.onKeyDown,
      onKeyDown = _ref$onKeyDown === void 0 ? function () {
    return undefined;
  } : _ref$onKeyDown,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? function () {
    return undefined;
  } : _ref$onFocus,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {
    return undefined;
  } : _ref$onBlur,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["option", "lookupText", "open", "error", "disabled", "disableOptionClearing", "disableLookup", "onToggleDropdown", "onClearOption", "onChange", "onKeyDown", "onFocus", "onBlur", "theme"]);

  var inputRef = useRef(null);
  return /*#__PURE__*/React.createElement(theme.Main, Object.assign({
    "data-test": "select-input-main"
  }, rest), /*#__PURE__*/React.createElement(Input, {
    ref: inputRef,
    value: lookupText,
    error: error,
    disabled: disabled,
    onChange: onChange,
    onKeyDown: onKeyDown,
    debounceTimeout: 50,
    readOnly: disableLookup,
    onFocus: onFocus,
    onBlur: onBlur,
    onClick: function onClick(e) {
      if (!disabled) {
        onToggleDropdown(e);
      }
    },
    theme: theme.TextInput
  }), /*#__PURE__*/React.createElement(theme.DropdownControl, {
    disabled: disabled,
    onMouseDown: function onMouseDown(e) {
      return e.nativeEvent.stopImmediatePropagation();
    },
    onClick: function onClick(e) {
      if (!disabled) {
        onToggleDropdown(e);
      }

      if (inputRef.current) {
        inputRef.current.focus();
      }
    },
    "data-test": "select-input-dropdown-control"
  }, /*#__PURE__*/React.createElement(theme.ArrowIcon, {
    color: daveGrey(),
    direction: open ? 'top' : 'bottom',
    width: 1
  })), option && !disableOptionClearing && !disabled ? /*#__PURE__*/React.createElement(theme.DeleteOptionControl, {
    onClick: function onClick(e) {
      return !disabled && onClearOption(e);
    },
    "data-test": "select-input-delete-option"
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    color: daveGrey(),
    width: 0.71
  })) : null, !lookupText ? /*#__PURE__*/React.createElement("div", {
    "data-test": "select-input-option-label"
  }, /*#__PURE__*/React.createElement(Input, {
    value: option ? option.label : '',
    readOnly: true,
    theme: theme.SelectedOption
  })) : null);
};

export default SelectInput;